import { SelectGroup } from "@/components/ui/select";
import OptionHelpers from "../../../helpers/OptionHelpers";

export function ConditionSelect({ currentExport, data, setData }) {
  if (
    currentExport == "asset" ||
    currentExport == "part repairable" ||
    currentExport == "part non repairable"
  ) {
    return (
      <SelectGroup
        label="Condition"
        menuPosition="fixed"
        isClearable
        placeholder="Select Condition"
        className="w-full"
        options={
          OptionHelpers.part_condition() ? OptionHelpers.part_condition() : []
        }
        value={
          OptionHelpers.part_condition() &&
          OptionHelpers.part_condition().filter(
            (option) => option.value === data.status,
          )
        }
        onChange={(e) => {
          setData({ ...data, status: e ? e.value : null });
        }}
      />
    );
  }
  return null;
}
